import React, { memo } from 'react';
import { CheckCircle2, ChevronRight, Star, ShieldCheck, Clock, Target, Briefcase, FileText, Users, Search, MessageSquare, Presentation, CheckSquare, Gift, ArrowRight } from 'lucide-react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    const pricingSection = document.getElementById('compra');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const checkoutUrl = 'https://checkout.sectordigital.online/cart/44092883238955:1';
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-blue-200" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      {/* 1. HERO SECTION */}
      <header className="bg-slate-900 text-white border-b border-slate-800 pt-6 pb-10 lg:pt-16 lg:pb-20 overflow-hidden relative min-h-[100svh] lg:min-h-0 flex items-center lg:block" data-id="element-3">
        <div className="absolute top-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-blue-900/40 via-slate-900 to-slate-900 -z-10" data-id="element-4"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full relative z-10" data-id="element-5">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-blue-500/20 text-blue-200 border border-blue-400/30 text-sm font-semibold mb-5 sm:mb-6" data-id="element-6">
            <Star className="w-4 h-4 fill-current" data-id="element-7" />
            KIT Recruiter PRO™
          </div>
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white mb-6 sm:mb-8 leading-[1.1] max-w-4xl mx-auto" data-id="element-8">
            DEJA DE IMPROVISAR EN TUS PROCESOS DE SELECCION
          </h1>

          {/* Product Mockup Image */}
          <div className="cursor-pointer group mb-6 sm:mb-8 mx-auto max-w-[260px] sm:max-w-md" onClick={scrollToPricing} data-id="element-9">
            <img src="https://cdn.magicpatterns.com/uploads/enA5a7ird9jyxba46BVALS/Diseno_sin_titulo_(27).png" alt="KIT Recruiter PRO - Mockup del producto" className="w-full h-auto transition-transform duration-300 group-hover:-translate-y-2 drop-shadow-2xl" data-id="element-10" />
          </div>

          <p className="text-lg sm:text-2xl font-medium text-slate-200 mb-3 sm:mb-4 max-w-3xl mx-auto" data-id="element-11">
            Ordená, filtrá y seleccioná candidatos en la mitad del tiempo.
          </p>
          <p className="text-base sm:text-lg text-slate-300 mb-7 sm:mb-10 max-w-2xl mx-auto" data-id="element-12">
            El sistema práctico para recruiters, selectores y profesionales de
            RRHH que quieren gestionar búsquedas con más claridad.
          </p>

          <div className="flex flex-col items-center gap-3" data-id="element-13">
            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-blue-600 hover:bg-blue-500 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg shadow-blue-600/40 transition-all hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-14">
              SÍ, QUIERO EL KIT AHORA
              <ChevronRight className="w-5 h-5" data-id="element-15" />
            </button>
            <div className="flex items-center gap-2 text-sm text-slate-400 font-medium" data-id="element-16">
              <Clock className="w-4 h-4" data-id="element-17" /> Acceso inmediato
              <span className="mx-1" data-id="element-18">·</span>
              <ShieldCheck className="w-4 h-4" data-id="element-19" /> Pago único y seguro
            </div>
          </div>
        </div>
      </header>

      {/* 2. INTRO & BENEFITS */}
      <section className="py-20 bg-slate-50" data-id="element-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-22">
            <h2 className="text-sm font-bold text-blue-600 tracking-widest uppercase mb-3" data-id="element-23">
              UN SISTEMA PARA DEJAR DE TRABAJAR A CIEGAS
            </h2>
            <h3 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6" data-id="element-24">
              KIT Recruiter PRO™
            </h3>
            <p className="text-xl font-medium text-slate-800 mb-4" data-id="element-25">
              Sistema práctico de selección en 7 etapas
            </p>
            <p className="text-lg text-slate-600" data-id="element-26">
              Creamos un sistema claro y aplicable para que dejes de manejar
              búsquedas como una suma de CVs, entrevistas y mensajes sueltos… y
              empieces a conducir cada proceso con orden, filtros y próximos
              pasos definidos.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-27">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200" data-id="element-28">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6" data-id="element-29">
                <Target className="w-6 h-6 text-blue-600" data-id="element-30" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3" data-id="element-31">
                MÁS ORDEN EN CADA BÚSQUEDA
              </h4>
              <p className="text-slate-600" data-id="element-32">
                Sabés qué preguntar, qué filtrar, qué registrar y qué validar en
                cada etapa del proceso.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200" data-id="element-33">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6" data-id="element-34">
                <Clock className="w-6 h-6 text-blue-600" data-id="element-35" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3" data-id="element-36">
                MENOS TIEMPO PERDIDO
              </h4>
              <p className="text-slate-600" data-id="element-37">
                Dejás de revisar perfiles sin criterio, entrevistar sin
                estructura o esperar feedback sin seguimiento.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200" data-id="element-38">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6" data-id="element-39">
                <Briefcase className="w-6 h-6 text-blue-600" data-id="element-40" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3" data-id="element-41">
                MÁS CRITERIO PROFESIONAL
              </h4>
              <p className="text-slate-600" data-id="element-42">
                Presentás candidatos con argumentos claros, fortalezas, dudas y
                recomendación concreta.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. QUÉ INCLUYE (7 ETAPAS) */}
      <section className="py-20 bg-white border-y border-slate-200" data-id="element-43">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
          <div className="text-center mb-16" data-id="element-45">
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6" data-id="element-46">
              QUÉ INCLUYE KIT RECRUITER PRO
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-47">
              Todo lo que necesitás para ordenar tus procesos de selección desde
              el primer contacto con el cliente hasta el cierre final de la
              búsqueda.
            </p>
            <div className="bg-blue-50 border border-blue-100 rounded-2xl p-8 text-left" data-id="element-48">
              <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-49">
                Guía Principal: KIT Recruiter PRO
              </h3>
              <p className="text-slate-700" data-id="element-50">
                El sistema completo para gestionar búsquedas activas con más
                claridad, estructura y velocidad.
              </p>
            </div>
          </div>

          <h3 className="text-2xl font-bold text-center text-slate-900 mb-12" data-id="element-51">
            Sistema Recruiter PRO™ en 7 etapas
          </h3>

          <div className="space-y-6" data-id="element-52">
            {[{
            num: '01',
            title: 'Briefing con el cliente',
            desc: 'Preguntas clave, criterios de búsqueda y acuerdos iniciales para no empezar con información incompleta.',
            icon: MessageSquare
          }, {
            num: '02',
            title: 'Diseño de la búsqueda',
            desc: 'Perfil ideal, filtros prioritarios, canales, palabras clave y estrategia antes de salir al mercado.',
            icon: FileText
          }, {
            num: '03',
            title: 'Atracción y sourcing',
            desc: 'Dónde buscar candidatos, cómo contactarlos y cómo aplicar un primer filtro sin perder tiempo.',
            icon: Search
          }, {
            num: '04',
            title: 'Filtro y evaluación de CVs',
            desc: 'Sistema para clasificar candidatos, detectar señales de encaje y registrar motivos de avance o descarte.',
            icon: Users
          }, {
            num: '05',
            title: 'Entrevista de selección',
            desc: 'Protocolo estructurado para preguntar, profundizar, evaluar y registrar cada candidato.',
            icon: MessageSquare
          }, {
            num: '06',
            title: 'Presentación al cliente',
            desc: 'Cómo armar una terna profesional con fortalezas, dudas, condiciones y recomendación.',
            icon: Presentation
          }, {
            num: '07',
            title: 'Seguimiento y cierre',
            desc: 'Cómo gestionar feedback, oferta, candidatos descartados, cierre e histórico del proceso.',
            icon: CheckSquare
          }].map((etapa, idx) => <div key={idx} className="flex gap-6 bg-slate-50 p-6 rounded-2xl border border-slate-100 hover:border-blue-200 transition-colors" data-id="element-53">
                <div className="flex-shrink-0 w-14 h-14 bg-white rounded-xl shadow-sm border border-slate-200 flex items-center justify-center text-xl font-black text-blue-600" data-id="element-54">
                  {etapa.num}
                </div>
                <div data-id="element-55">
                  <h4 className="text-xl font-bold text-slate-900 mb-2" data-id="element-56">
                    {etapa.title}
                  </h4>
                  <p className="text-slate-600" data-id="element-57">{etapa.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-16 text-center" data-id="element-58">
            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white text-lg font-bold py-4 px-10 rounded-xl shadow-lg shadow-blue-600/30 transition-all hover:-translate-y-0.5 inline-flex items-center justify-center gap-2" data-id="element-59">
              SÍ, QUIERO EL KIT AHORA
              <ChevronRight className="w-5 h-5" data-id="element-60" />
            </button>
          </div>
        </div>
      </section>

      {/* 4. BONUSES */}
      <section className="py-20 bg-slate-900 text-white relative overflow-hidden" data-id="element-61">
        <div className="absolute top-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-blue-900/40 via-slate-900 to-slate-900 -z-10" data-id="element-62"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
          <div className="text-center mb-16" data-id="element-64">
            <div className="inline-block bg-yellow-400 text-yellow-950 font-bold px-4 py-1.5 rounded-full text-sm mb-6 animate-pulse" data-id="element-65">
              ¡GRATIS POR EL DÍA DE HOY!
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-66">
              OFERTA ESPECIAL: BONUS PROFESIONALES
            </h2>
            <p className="text-xl text-blue-200 font-medium" data-id="element-67">
              INCLUIDOS CON TU COMPRA
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-68">
            {/* Bonus 1 */}
            <div className="bg-slate-800 rounded-2xl p-8 border border-slate-700 relative" data-id="element-69">
              <div className="absolute -top-4 -right-4 bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg transform rotate-3" data-id="element-70">
                ¡Incluido hoy!
              </div>
              <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center mb-6" data-id="element-71">
                <Gift className="w-6 h-6 text-blue-400" data-id="element-72" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-73">
                BONUS #1 — Planillas de Seguimiento de Candidatos
              </h3>
              <p className="text-slate-300 mb-6" data-id="element-74">
                Planillas descargables para registrar y seguir candidatos
                durante todo el proceso.
              </p>
              <p className="font-semibold text-slate-200 mb-4" data-id="element-75">
                Incluye planillas para:
              </p>
              <ul className="space-y-3 mb-6" data-id="element-76">
                {['datos del candidato;', 'estado actual;', 'registro de entrevistas;', 'evaluación por criterios;', 'próximos pasos;', 'observaciones finales;', 'decisión.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-300" data-id="element-77">
                    <CheckCircle2 className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" data-id="element-78" />
                    <span data-id="element-79">{item}</span>
                  </li>)}
              </ul>
              <p className="text-sm text-slate-400 italic border-t border-slate-700 pt-4" data-id="element-80">
                Para que no pierdas información entre etapas y puedas saber
                rápidamente qué pasa con cada perfil.
              </p>
            </div>

            {/* Bonus 2 */}
            <div className="bg-slate-800 rounded-2xl p-8 border border-slate-700 relative" data-id="element-81">
              <div className="absolute -top-4 -right-4 bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg transform rotate-3" data-id="element-82">
                ¡Incluido hoy!
              </div>
              <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center mb-6" data-id="element-83">
                <Gift className="w-6 h-6 text-blue-400" data-id="element-84" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-85">
                BONUS #2 — Planilla de Gestión de Búsquedas Activas
              </h3>
              <p className="text-slate-300 mb-6" data-id="element-86">
                Sistema multi-hoja para recruiters que manejan varias posiciones
                al mismo tiempo.
              </p>
              <p className="font-semibold text-slate-200 mb-4" data-id="element-87">
                Incluye hojas para:
              </p>
              <ul className="space-y-3 mb-6" data-id="element-88">
                {['panel de control general;', 'ficha de posición;', 'seguimiento de candidatos por búsqueda;', 'gestión de clientes;', 'agenda de entrevistas;', 'pipeline de cierre;', 'registro histórico.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-300" data-id="element-89">
                    <CheckCircle2 className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" data-id="element-90" />
                    <span data-id="element-91">{item}</span>
                  </li>)}
              </ul>
              <p className="text-sm text-slate-400 italic border-t border-slate-700 pt-4" data-id="element-92">
                Para ver tus búsquedas activas, candidatos, clientes,
                entrevistas y cierres en un solo lugar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. TARGET & RESULTS */}
      <section className="py-20 bg-white" data-id="element-93">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
          <div className="grid md:grid-cols-2 gap-12 lg:gap-20" data-id="element-95">
            {/* Para vos si */}
            <div data-id="element-96">
              <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-8" data-id="element-97">
                ESTE KIT ES PARA VOS SI...
              </h2>
              <ul className="space-y-5" data-id="element-98">
                {['Sos recruiter, selector o consultor de talento.', 'Manejás varias búsquedas al mismo tiempo.', 'Sentís que cada búsqueda se te desordena.', 'Revisás muchos CVs y perdés tiempo filtrando perfiles que no encajan.', 'Buscás un sistema práctico, simple y aplicable desde el primer día.'].map((item, i) => <li key={i} className="flex items-start gap-4 p-4 rounded-xl bg-red-50 border border-red-100" data-id="element-99">
                    <div className="w-6 h-6 rounded-full bg-red-200 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-100">
                      <div className="w-2 h-2 rounded-full bg-red-600" data-id="element-101"></div>
                    </div>
                    <span className="text-slate-800 font-medium" data-id="element-102">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Resultados */}
            <div data-id="element-103">
              <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-8" data-id="element-104">
                EL RESULTADO:
              </h2>
              <ul className="space-y-5" data-id="element-105">
                {['Entrás a cada búsqueda con más claridad.', 'Filtrás CVs con criterios concretos.', 'Entrevistás con estructura, no por intuición.', 'Presentás candidatos con más criterio profesional.', 'Seguís cada búsqueda hasta el cierre sin perder información.'].map((item, i) => <li key={i} className="flex items-start gap-4 p-4 rounded-xl bg-green-50 border border-green-100" data-id="element-106">
                    <CheckCircle2 className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-107" />
                    <span className="text-slate-800 font-medium" data-id="element-108">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 6. PRICING / PURCHASE SECTION */}
      <section className="py-24 bg-slate-900 text-white border-t border-slate-800 relative overflow-hidden" data-id="element-109">
        <div className="absolute top-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-blue-900/40 via-slate-900 to-slate-900 pointer-events-none" data-id="element-110"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-111">
          <div className="text-center mb-12" data-id="element-112">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-6" data-id="element-113">
              TODO LO QUE NECESITÁS PARA ORDENAR TUS BÚSQUEDAS DE SELECCIÓN
            </h2>
            <p className="text-xl text-slate-300 font-medium" data-id="element-114">
              Un solo pago. Sin suscripciones. Tuyo para siempre.
            </p>
          </div>

          <div id="compra" className="max-w-2xl mx-auto bg-white rounded-3xl shadow-2xl border-2 border-blue-500 overflow-hidden relative scroll-mt-8" data-id="element-115">
            <div className="bg-blue-600 text-white text-center py-3 font-bold tracking-wide uppercase text-sm" data-id="element-116">
              Oferta Especial
            </div>

            <div className="p-8 sm:p-12" data-id="element-117">
              <h3 className="text-3xl font-bold text-center text-slate-900 mb-8" data-id="element-118">
                KIT RECRUITER PRO
              </h3>

              <ul className="space-y-4 mb-10" data-id="element-119">
                {['Guía Principal Completa;', 'Sistema Recruiter PRO™ en 7 etapas;', 'BONUS: Planillas de Seguimiento de Candidatos;', 'BONUS: Planilla de Gestión de Búsquedas Activas.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-120">
                    <CheckCircle2 className="w-6 h-6 text-blue-600 flex-shrink-0" data-id="element-121" />
                    <span className="text-lg text-slate-700 font-medium" data-id="element-122">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="text-center mb-8 p-6 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-123">
                <div className="text-slate-400 text-xl font-bold line-through mb-2" data-id="element-124">
                  $49.990 ARS
                </div>
                <div className="text-5xl sm:text-6xl font-black text-slate-900 mb-4" data-id="element-125">
                  $19.990 ARS
                </div>
                <p className="text-slate-500 font-medium" data-id="element-126">
                  Pago único · Sin cargos ocultos
                </p>
              </div>

              <a href={checkoutUrl} className="block w-full bg-blue-600 hover:bg-blue-700 text-white text-xl font-bold py-5 px-8 rounded-xl shadow-xl shadow-blue-600/30 transition-all hover:-translate-y-1 text-center flex items-center justify-center gap-3" data-id="element-127">
                SÍ, QUIERO EL KIT AHORA
                <ArrowRight className="w-6 h-6" data-id="element-128" />
              </a>

              <div className="mt-6 flex items-center justify-center gap-4 text-sm text-slate-500 font-medium" data-id="element-129">
                <div className="flex items-center gap-1.5" data-id="element-130">
                  <Clock className="w-4 h-4" data-id="element-131" /> Acceso inmediato
                </div>
                <span className="text-slate-300" data-id="element-132">|</span>
                <div className="flex items-center gap-1.5" data-id="element-133">
                  <ShieldCheck className="w-4 h-4" data-id="element-134" /> Garantía 7 días
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 7. TESTIMONIALS */}
      <section className="py-20 bg-white border-t border-slate-200" data-id="element-135">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-137">
            {[{
            quote: 'Antes manejaba todo de memoria y se me escapaban candidatos. Ahora cada búsqueda tiene un orden claro y mis clientes lo notan.',
            initials: 'MG',
            name: 'Macarena Giménez',
            role: 'Recruiter Senior · Buenos Aires'
          }, {
            quote: 'El módulo de entrevistas me cambió la forma de trabajar. Dejé de improvisar y ahora presento ternas mucho más sólidas.',
            initials: 'LM',
            name: 'Lucía Martínez',
            role: 'Talent Acquisition · Córdoba'
          }, {
            quote: 'Manejo 5 búsquedas en simultáneo y siempre era un caos. Las planillas de seguimiento son exactamente lo que necesitaba para no perder el control.',
            initials: 'FR',
            name: 'Florencia Ruiz',
            role: 'Consultora de RRHH · Rosario'
          }, {
            quote: 'Vale cada centavo. Solo con el tiempo que me ahorro filtrando CVs ya recuperé la inversión el primer día.',
            initials: 'TV',
            name: 'Tomás Villalba',
            role: 'Selector IT · Mendoza'
          }, {
            quote: 'Me dio la estructura que me faltaba para verme más profesional frente a los hiring managers. Súper recomendable.',
            initials: 'AL',
            name: 'Agustina López',
            role: 'Analista de Selección · La Plata'
          }].map((t, i) => <div key={i} className="bg-slate-50 p-8 rounded-2xl border border-slate-100" data-id="element-138">
                <div className="flex gap-1 mb-4" data-id="element-139">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-140" />)}
                </div>
                <p className="text-slate-700 italic mb-6" data-id="element-141">"{t.quote}"</p>
                <div className="flex items-center gap-4" data-id="element-142">
                  <div className="w-12 h-12 bg-blue-100 text-blue-700 font-bold rounded-full flex items-center justify-center" data-id="element-143">
                    {t.initials}
                  </div>
                  <div data-id="element-144">
                    <div className="font-bold text-slate-900" data-id="element-145">{t.name}</div>
                    <div className="text-sm text-slate-500" data-id="element-146">{t.role}</div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. FOOTER */}
      <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm border-t border-slate-800" data-id="element-147">
        <div className="max-w-4xl mx-auto px-4" data-id="element-148">
          <p className="mb-4" data-id="element-149">
            © 2026 KIT Recruiter PRO. Todos los derechos reservados.
          </p>
          <p className="text-xs text-slate-500 max-w-2xl mx-auto leading-relaxed" data-id="element-150">
            Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
            este sitio NO está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </footer>
    </div>;
}